<script>
import 'intersection-observer'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

/** 旧バージョン用 TODO 新バージョンへ移行 */
import 'vue-virtual-scroller-0.12/dist/vue-virtual-scroller.css'
import { VirtualScroller } from 'vue-virtual-scroller-0.12'

export { DynamicScroller, DynamicScrollerItem, RecycleScroller } from 'vue-virtual-scroller'
export { default as CellMeasurer } from './CellMeasurer'

export default {
  name: 'VirtualScroller',
  extends: VirtualScroller,
  props: {
    heightCache: { type: Array },
  },
  watch: {
    heightCache() {
      this.updateVisibleItems(true)
    },
  },
  methods: {
    /**
     * @override
     * https://github.com/Akryum/vue-virtual-scroller/blob/cf249252661968936f80e5e33e061eb32950d8d8/src/components/VirtualScroller.vue#L161-L277
     */
    updateVisibleItems(force = false) {
      /* eslint-disable */
      if (!this.$_updateDirty) {
        this.$_updateDirty = true
        this.$nextTick(() => {
          this.$_updateDirty = false

          const l = this.items.length
          const scroll = this.getScroll()
          const items = this.items
          const itemHeight = this.itemHeight
          let containerHeight, offsetTop
          if (scroll) {
            let startIndex = -1
            let endIndex = -1

            const buffer = parseInt(this.buffer)
            const poolSize = parseInt(this.poolSize)
            const scrollTop = ~~(scroll.top / poolSize) * poolSize - buffer
            const scrollBottom = Math.ceil(scroll.bottom / poolSize) * poolSize + buffer

            if (
              !force &&
              ((scrollTop === this.$_oldScrollTop && scrollBottom === this.$_oldScrollBottom) || this.$_skip)
            ) {
              this.$_skip = false
              return
            } else {
              this.$_oldScrollTop = scrollTop
              this.$_oldScrollBottom = scrollBottom
            }

            // heightCache対応版 Variable height mode
            /* eslint-enable */
            if (itemHeight === null && l) {
              const heights = this.heightCache
              const minHeight = +this.minItemHeight
              startIndex = 0
              endIndex = 0
              offsetTop = 0
              containerHeight = 0
              this.items.forEach((item, i) => {
                const height = heights[i] || item.height || minHeight
                containerHeight += height
                if (containerHeight < scrollTop) {
                  startIndex = i + 1
                  offsetTop += height
                }
                if (containerHeight < scrollBottom) {
                  endIndex = Math.min(i + 1, l)
                }
              })
              /* eslint-disable */
            } else {
              // Fixed height mode
              startIndex = ~~(scrollTop / itemHeight)
              endIndex = Math.ceil(scrollBottom / itemHeight)

              // Bounds
              startIndex < 0 && (startIndex = 0)
              endIndex > l && (endIndex = l)

              offsetTop = startIndex * itemHeight
              containerHeight = l * itemHeight
            }

            if (
              force ||
              this.$_startIndex !== startIndex ||
              this.$_endIndex !== endIndex ||
              this.$_offsetTop !== offsetTop ||
              this.$_height !== containerHeight ||
              this.$_length !== l
            ) {
              this.keysEnabled = !(startIndex > this.$_endIndex || endIndex < this.$_startIndex)

              this.itemContainerStyle = {
                height: containerHeight + 'px',
              }
              this.itemsStyle = {
                marginTop: offsetTop + 'px',
              }

              if (this.delayPreviousItems) {
                // Add next items
                this.visibleItems = items.slice(this.$_startIndex, endIndex)
                // Remove previous items
                this.$nextTick(() => {
                  this.visibleItems = items.slice(startIndex, endIndex)
                })
              } else {
                this.visibleItems = items.slice(startIndex, endIndex)
              }

              this.emitUpdate && this.$emit('update', startIndex, endIndex)

              this.$_startIndex = startIndex
              this.$_endIndex = endIndex
              this.$_length = l
              this.$_offsetTop = offsetTop
              this.$_height = containerHeight
            }
          }
        })
      }
      /* eslint-enable */
    },
  },
}
</script>

<style lang="postcss">
.virtual-scroller:not(.page-mode) {
  flex: 1 1 auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.vue-recycle-scroller {
  height: 100%;
  transform: translateZ(0); /* https://gnavi-work.gnavi.co.jp/jira/browse/GNAVI_RMS-736 の抑制 */
}
</style>
